import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { SESSION_TOKEN } from '../config';

const link = createUploadLink({
  uri: process.env.REACT_APP_GQL_URI,
});

export const apolloClient = new ApolloClient({
  link: setContext(() => {
    console.log(localStorage.getItem(SESSION_TOKEN));
    return {
      headers: {
        token: localStorage.getItem(SESSION_TOKEN),
      },
    };
  }).concat(link),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      nextFetchPolicy(lastFetchPolicy) {
        if (
          lastFetchPolicy === 'cache-and-network' ||
          lastFetchPolicy === 'network-only'
        ) {
          return 'cache-first';
        }
        return lastFetchPolicy;
      },
    },
  },
});
